const assetBase = process.env.PUBLIC_URL || "";

const imageByVisualKey = {
  hero: `${assetBase}/assets/umeed-products/heritage-tote-angle.jpeg`,
  tote: `${assetBase}/assets/umeed-products/heritage-tote-front.jpeg`,
  "tote-alt": `${assetBase}/assets/umeed-products/desert-dawn-tote-front.jpeg`,
  "tote-market": `${assetBase}/assets/umeed-products/market-day-tote-front.jpeg`,
  pouch: `${assetBase}/assets/umeed-products/pouch-new-front.jpeg`,
  "pouch-alt": `${assetBase}/assets/umeed-products/pouch-new-angle.jpeg`,
  "pouch-new": `${assetBase}/assets/umeed-products/pouch-new-detail.jpeg`,
  "coin-holder": `${assetBase}/assets/umeed-products/coin-holder-front.jpeg`,
  pencil: `${assetBase}/assets/umeed-products/pouch-new-angle.jpeg`,
};

export function TextileVisual({ visualKey = "tote", label, testId }) {
  const imageSrc = imageByVisualKey[visualKey];

  return (
    <div
      className={`textile-visual textile-visual--${visualKey} ${imageSrc ? "textile-visual--photo" : ""}`}
      role="img"
      aria-label={label}
      data-testid={testId}
    >
      {imageSrc ? (
        <img src={imageSrc} alt="" aria-hidden="true" loading={visualKey === "hero" ? "eager" : "lazy"} />
      ) : (
        <>
          <span className="textile-visual__loom" />
          <span className="textile-visual__thread textile-visual__thread--one" />
          <span className="textile-visual__thread textile-visual__thread--two" />
          <span className="textile-visual__motif textile-visual__motif--one" />
          <span className="textile-visual__motif textile-visual__motif--two" />
          <span className="textile-visual__shape" />
        </>
      )}
    </div>
  );
}
